module.exports = __webpack_public_path__ + "img/student_28.e7471996.png";